/**
 * Style tokens for the Creator Index, matching the custom properties declared
 * in `index.module.css`. Referenced from inline styles so the editorial palette
 * stays theme-aware in both light and dark without repeating literals.
 */
export const INK = {
  base: 'var(--ink)',
  soft: 'var(--ink-soft)',
  faint: 'var(--ink-faint)',
  accent: 'var(--accent)',
  rule: 'var(--rule)',
  paperRaised: 'var(--paper-raised)',
} as const;

/** Small-caps editorial label, used for section labels, figure numbers and table headers. */
export const LABEL_CLASS = 'font-display font-bold uppercase tracking-widest text-xs';
